module.exports = __webpack_public_path__ + "f81905c9ce4bfaccfd1ca209cc88a5e8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-info/sp-info.html
// module id = 1067
// module chunks = 0